export default "__VITE_ASSET__B6DvaOH8__"